import { Form, Input, InputNumber } from "antd";
import { requiredField } from "../common/common";
import SimpleFormPage from "../common/SimpleFormPage";

export default function () {
  return (
    <SimpleFormPage title="Nuova categoria allestimento" path="setupType">
      <Form.Item label="Descrizione" rules={[requiredField]} name="description">
        <Input />
      </Form.Item>

      <Form.Item label="Revisione ogni" name="inspectionMonths">
        <InputNumber  controls={false} precision={0} suffix="mesi" />
      </Form.Item>
    </SimpleFormPage>
  );
}
